import React from 'react';
import * as R from 'ramda';

import { NewProgressField } from 'resources/common';

const QuizProgressField = ({ record }) => {
  const submissionCount = R.length(R.propOr([], 'submissions')(record));
  const progress = R.defaultTo(
    0,
    Math.round((100 * submissionCount) / record.expected)
  );
  const text = `${progress}%`;
  return <NewProgressField value={progress} text={text} />;
};

export default QuizProgressField;
